import { defineComponent as _defineComponent } from 'vue'
import AuthView from "./AuthView.vue";
import { RouterView, useRoute } from "vue-router";
import NavigationView from "@/components/navigation/NavigationView.vue";
import EnvironmentIndicator from "./EnvironmentIndicator.vue";
import AppUpdate from "./AppUpdate.vue";
import AppNotification from "./AppNotification.vue";
import * as appInfo from "@/lib/appInfo";
import useContextMenu from "@/composables/useContextMenu";
import useDialog from "@/composables/useDialog";
import ServerMaintenance from "./ServerMaintenance.vue";
import { useAppStatusStore } from "@/stores/appStatus.store";
import { useUserStore } from "@/stores/user.store";
import { isEmployeeOnly } from "@/auth/auth.roles";
import { ref } from "vue";
import logger from "@/lib/logger";
import MobileEmployeeNavigation from "@/components/navigation/MobileEmployeeNavigation.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {
  __expose();

const { contextMenu } = useContextMenu();
const { dialog } = useDialog();
const route = useRoute();
const appStatusStore = useAppStatusStore();
const userStore = useUserStore();
const serverMaintenance = ref(false);
appStatusStore.$subscribe((_mutation, state) => {
  serverMaintenance.value = state.serverMaintenance;
});
  
const versionString = `Version: ${appInfo.getAppVersion()}
• Built: ${appInfo.getBuildDate()}
• Build: ${appInfo.getBuildNumber()}
• Hash: ${appInfo.getCommitHash()}`;
logger.info(versionString);

const __returned__ = { contextMenu, dialog, route, appStatusStore, userStore, serverMaintenance, versionString, AuthView, get RouterView() { return RouterView }, NavigationView, EnvironmentIndicator, AppUpdate, AppNotification, ServerMaintenance, get isEmployeeOnly() { return isEmployeeOnly }, MobileEmployeeNavigation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})